"use client";
import { H as t, s, a as r } from "./index-B6eLFvxS.js";
import "react";
class d extends t {
  $$PROVIDER_TYPE = "AUDIO";
  get type() {
    return "audio";
  }
  airPlay;
  constructor(i, e) {
    super(i, e), s(() => {
      this.airPlay = new r(this.media, e);
    }, this.scope);
  }
  setup() {
    super.setup(), this.type === "audio" && this.ctx.notify("provider-setup", this);
  }
  /**
   * The native HTML `<audio>` element.
   *
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLAudioElement}
   */
  get audio() {
    return this.media;
  }
}
export {
  d as AudioProvider
};
